import React from "react";
import neurapulseLogo from "src/assets/images/neurapulse/neurapulse-colored 1.png";
import clsx from "clsx";
import styles from "./NeurapulseConfigDialogHeader.module.css";

// header
export const NeurapulseConfigDialogHeader = () => {
	return (
		<div>
			<a href="https://neurapulse.com" target="_blank" rel="noreferrer">
				<img src={neurapulseLogo} className={clsx(styles.neurapulseLogo)} />
			</a>
			<p className={clsx(styles.neurapulseTagline)}>
				Fitness-for-duty testing deployed to mobile devices. Identify and
				mitigate accident risk quickly, securely, and without additional
				staffing.
			</p>
		</div>
	);
};
